import { StrictMode } from 'react';

import { LicenseInfo } from '@mui/x-license';
import { createRoot } from 'react-dom/client';

import App from './App';
import { env } from './env';

// Register the MUI X (Pro) license once, before any MUI X component renders.
if (env.muiLicenseKey) {
  LicenseInfo.setLicenseKey(env.muiLicenseKey);
}

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Root element #root not found in the DOM.');

createRoot(rootEl).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
